import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { FailureDescription } from "../../../model/form.model";
import { KeyValueItem } from "../../../../../model/general.model";
import { TranslateService } from "@ngx-translate/core";
import { DATE_TIME_FORMAT, getLocalDate } from "../../../../../utils/date.utils";
import { ConnectionStatusService } from 'src/app/services/connection-status.service';

@Component({
  selector: 'failure-preview-dialog',
  templateUrl: './failure-preview-dialog.component.html',
  styleUrls: ['./failure-preview-dialog.component.scss']
})
export class FailurePreviewDialogComponent {
  networkStatus$ = this.connectionStatusService.networkStatus$;
  details: KeyValueItem[] = [];
  constructor(
    public dialogRef: MatDialogRef<FailurePreviewDialogComponent>,
    private translate: TranslateService,
    private connectionStatusService: ConnectionStatusService,
    @Inject(MAT_DIALOG_DATA) public data: FailureDescription,
  ) {
    this.prepareDetails();
  }

  private prepareDetails() {

    const name = {
      key: this.translate.instant('NAME'),
      value: this.data.name
    }

    this.details.push(name);

    const category = {
      key: this.translate.instant('CATEGORY'),
      value: this.data.category ? this.translate.instant(this.data.category) : '---'
    }
    this.details.push(category);

    const codes = {
      key: this.translate.instant('FAILURE_CODE'),
      value: this.translate.instant(this.data.failureCodes.map(x => x.code).join(', '))
    }

    this.details.push(codes);

    if (this.data.description) {
      const description = {
        key: this.translate.instant('DESCRIPTION'),
        value: this.data.description
      }

      this.details.push(description)
    }

    if (this.data.comment) {
      const comment = {
        key: this.translate.instant('COMMENT'),
        value: this.data.comment
      }

      this.details.push(comment);
    }

    if (this.data.createdOn) {
      const createdOn = {
        key: this.translate.instant('CREATED_ON'),
        value: getLocalDate(this.data.createdOn, DATE_TIME_FORMAT)
      }

      this.details.push(createdOn);
    }
  }
}
